import React, { useContext } from 'react';
import { Container, Navbar, Nav, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { AppContext } from '../context';
import { navbarItems } from '../data/general';
import brandImage from '../../logo.png';
import RightNavDesktop from './RightNavDesktop';

const Navigation = () => {
  const { userAgent } = useContext(AppContext);

  return (
    <Navbar bg="white" expand="lg" fixed="top" className="shadow-sm">
      <Container>
        <Link to="/" className="navbar-brand p-0">
          <Image fluid src={brandImage} alt="Geeks Sydney" />
        </Link>
        {
          userAgent.isMobile &&
            <div className="d-inline-block d-lg-none ml-auto mr-3">
              <Link 
                to="/book-online"
                className="Header-BookOnline__Btn btn btn-sm btn-outline-primary"
              >Book Online</Link>
            </div>
        }
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="pl-lg-5 ml-lg-5 mr-auto">
            {
              navbarItems.map((item, index) => (
                <Link 
                  key={index} 
                  to={item.slug} 
                  className="nav-link text-dark"
                >{item.name} </Link>
              ))
            }
          </Nav>
        </Navbar.Collapse>
        { !userAgent.isMobile && <RightNavDesktop /> }
      </Container>
    </Navbar>
  );
}

export default Navigation;